// import {
//   Id
// Request,
// RequestAgencyStatus,
// RequestTicket,
// RequestTicketType,
// ResponseDataPaginate
// } from 'src/types'

export enum PartnerHotelActionTypes {
  GET_PARTNER_HOTELS = '@partnerHotels/GET_PARTNER_HOTELS',
  GET_PARTNER_HOTELS_FAILURE = '@partnerHotels/GET_PARTNER_HOTELS_FAILURE',
  GET_PARTNER_HOTELS_SUCCESS = '@partnerHotels/GET_PARTNER_HOTELS_SUCCESS',
  SEND_PARTNER_HOTEL = '@partnerHotels/SEND_PARTNER_HOTEL',
  SEND_PARTNER_HOTEL_FAILURE = '@partnerHotels/SEND_PARTNER_HOTEL_FAILURE',
  SEND_PARTNER_HOTEL_SUCCESS = '@partnerHotels/SEND_PARTNER_HOTEL_SUCCESS'
}

export type ResponseDataRequests = {
  partner_hotels: ResponseDataRequestsItem[]
}

export interface ResponseDataRequestsItem {
  partner_hotel_number: number
  hotel_class: string
  hotel_image_url: string
  brand_name: string
  pool: boolean
  laundry: boolean
  parking: boolean
  restaurant: boolean
  nights: number
  information: string
  refundable: boolean
  category_stars: number
}

export type ResponseDataRequestTotals = {
  request_totals: {
    total_emissions: number
    total_quotations: number
  }
}

export type PartnerHotelsState = ResponseDataRequestTotals & {
  readonly error: string
  readonly list: ResponseDataRequestsItem[]
  readonly loading: boolean
  readonly sendPartnerHotelsError: string
  readonly sendPartnerHotelsLoading: boolean
  readonly total_results: number
}
